import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestService } from '@app/core/api/rest.service';
import { PayloadArticle } from '@app/core/state/news/payloadarticle';
import { PayloadString } from '@pezi/entities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestNewsService extends RestService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  getNews(): Observable<PayloadArticle> {
    return this.http
      .get<PayloadArticle>(this.baseUrl + '/news', this.httpOptions);
  }

  getNewsById(newsId: number): Observable<PayloadArticle> {
    return this.http
      .get<PayloadArticle>(this.baseUrl + '/news/detail/'+newsId, this.httpOptions);
  }

  getStaticServerUrl(): Observable<PayloadString> {
    return this.http
      .get<PayloadString>(this.baseUrl + '/news/staticserverurl', this.httpOptions);
  }
}
